export interface UserCollectionDtoInterface {
  id: string;
  name: string;
  description: string;
  creationTime: number;
  itemsCount: number;
}

export class UserCollectionDto implements UserCollectionDtoInterface{

  constructor(public id: string,public name: string,public description: string,public creationTime: number,public itemsCount: number) {
  }

  public static create(name: string){
    return new UserCollectionDto('',name, '', null, 0);
  }

}
